import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { Rest_logistics } from '../../../services/rest_client_logistics';
import { AnalysisConfigurationService } from '../../../services/analysis-configuration.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { RestExtTask } from 'app/modules/task/rest-client-task-extension';
import { Rest } from 'app/rest/rest_client';


@Component({
  selector: 'app-analysis-configuration',
  templateUrl: './analysis-configuration.component.html',
  styleUrls: ['./analysis-configuration.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers:[AnalysisConfigurationService]
})
export class AnalysisConfigurationComponent extends EntityFormComponent<Rest_logistics.AnalysisConfiguration>{
  time1: number;
  time2: number;
  color1: string;
  color2: string;
  view_analize:boolean;
  view_attributes:boolean ;
   user: Rest.User;
   configurationPlanner: Rest_logistics.AnalysisConfiguration;
   confplannerclass: Rest_logistics.parametersplanner;
   confentity:Rest_logistics.parametersplanner;
   autoPC:boolean=false
  constructor(
    private analysisConfigurationService: AnalysisConfigurationService,
    notificationsService: NotificationsService,
    protected i18n: I18nService,
    private authenticationService: AuthenticationService,
    public translate: TranslateService,
) {
    super(analysisConfigurationService, notificationsService, i18n, authenticationService)
    {
               this.confentity={attributes:{autoCP:false}};
    }


}

  ngOnInit(): void {
    this.isNew = true;
         this.confentity={attributes:{autoCP:false}};
    this.analysisConfigurationService.getConfiguration().then((response) => {
      this.entity = response;
      if ((this.entity.parameters) && (this.entity.parameters.data && this.entity.parameters.data.length > 0)) {
        this.time1 = this.entity.parameters.data[0].time;
        this.color1 = this.entity.parameters.data[0].color;
        this.time2 = this.entity.parameters.data[1].time;
        this.color2 = this.entity.parameters.data[1].color;
      }
      this.setColumns();
    });
    this.user = this.authenticationService.user;
    this.view_analize = RestExtTask.hasPermissionrp(RestExtTask.ActionTaskEnum.TASK_ANALYSIS_VIEW, this.user);
    this.view_attributes= RestExtTask.hasPermissionrp(RestExtTask.ActionTaskEnum.TASK_ATTRIBUTES_VIEW, this.user);

  }


     setColumns() {
      this.autoPC = false;
      this.configurationPlanner = this.entity;
      if ((this.configurationPlanner !== null) && (this.configurationPlanner.parametersplanner !== "")) {
         this.confplannerclass = JSON.parse(this.configurationPlanner.parametersplanner);
         if (this.confplannerclass.attributes.autoCP !== null) {
          this.confentity.attributes.autoCP= this.confplannerclass.attributes.autoCP;
          this.autoPC = this.confplannerclass.attributes.autoCP;
         }
      }
    }

 saveChanges(): void {

    if(this.validate()){
      var analysisConfigurationParameters = [
        {
          time: this.time1,
          color: this.color1
        },
        {
          time: this.time2,
          color: this.color2
        }
      ];
      if (!this.entity.parameters) {
        this.entity.parameters = { data: [] };
      }
      this.entity.parameters.data = analysisConfigurationParameters;
      this.confentity.attributes.autoCP = this.autoPC;
      this.entity.parametersplanner = JSON.stringify(this.confentity);

      this.analysisConfigurationService.create(this.entity).then((response) => {
        this.notificationsService.add(Severity.success, '', this.translate.instant('general.createSuccessfull'));

      });
    }
    
  }

  validate(){

    if (this.view_analize){
      if (!this.time1 || !this.color1 || !this.time2 || !this.color2 ) {
          this.notificationsService.add(Severity.warn,'',this.translate.instant('error.required-field.generic'));
          return false;
      }
    }
      return true;
    
  }


}
